import React from 'react';
import { Hint, HintActionButton, HintCloseButton, HintContent } from 'fronton-react';

type OriginalProductHintProps = {
  open: boolean;
  close: () => void;
  anchor: React.ReactElement;
  text: {
    actionButton: string;
    header: string;
    paragraph: string;
  };
};

const DATA_QA_ORIGINAL_PRODUCT_HINT = 'original-product-hint';
const DATA_QA_ORIGINAL_PRODUCT_HINT_CLOSE_BUTTON = 'original-product-hint-close-button';
const DATA_QA_ORIGINAL_PRODUCT_HINT_ACTION_BUTTON = 'original-product-hint-action-button';

export const OriginalProductHint: React.FC<OriginalProductHintProps> = ({
  close,
  open,
  anchor,
  text: { actionButton, header, paragraph },
}) => {
  return (
    <Hint
      data-testid={DATA_QA_ORIGINAL_PRODUCT_HINT}
      anchor={anchor}
      placement="bottom"
      open={open}
      closeButton={
        <HintCloseButton data-testid={DATA_QA_ORIGINAL_PRODUCT_HINT_CLOSE_BUTTON} onClick={close} />
      }
      actionButton={
        <HintActionButton data-testid={DATA_QA_ORIGINAL_PRODUCT_HINT_ACTION_BUTTON} onClick={close}>
          {actionButton}
        </HintActionButton>
      }
    >
      <HintContent header={header} paragraph={paragraph} />
    </Hint>
  );
};
